import { createFileRoute } from "@tanstack/react-router";

import { RequireAuth } from "../features/auth/RequireAuth";
import { ProfilePage } from "../features/profile/ProfilePage";

export const Route = createFileRoute("/profile")({
  component: () => (
    <RequireAuth>
      {(user) => (
        <ProfilePage uid={user.uid} email={user.email} signOut={user.signOut} />
      )}
    </RequireAuth>
  ),
});
